const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const initialState = Immutable.fromJS({
    accountId: '',
    accountIsDirty: false,
    valid: false,
    hasInsufficientBalance: false
});

function validateStep(state) {
    return state.merge({
        valid: !!state.get('accountId'),
        accountIsDirty: true
    });
}

function hireCardMetallicStep2(state = initialState, action = { type: null }) {
    switch (action.type) {
        case actionTypes.HIRE_CARD_METALLIC_VALIDATE_STEP:
            return validateStep(state, action.payload.valid);

        case actionTypes.HIRE_CARD_METALLIC_SET_ACCOUNT:
            return state.merge({
                accountId: action.payload.account.accountId,
                accountIsDirty: true,
                hasInsufficientBalance: action.payload.account.hasInsufficientBalance
            });

        default:
            return state;
    }
}

module.exports = hireCardMetallicStep2;
